import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AdditionalServiceAddon, AdditionalServiceAddonCard } from 'src/app/core/models/additional-service-addon';
import { EverGreenTile } from 'src/app/features/user-permissions/models/service-addon';
import {
  repairServicesCrossSelling,
  orderTrackingCrossSelling,
  shopCrossSelling,
  atmsCrossSelling,
  cyberDashboardCrossSelling,
  managedServicesCrossSelling,
  userPermissions,
  connectivityServicesCrossSelling,
} from 'src/app/core/constants/routes';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/features/secured-skeleton/services/header.service';
import { ServiceAddonNames } from 'src/app/core/models/service-addon-roles';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'additonal-services',
  templateUrl: './additonal-services.component.html',
  styleUrls: ['./additonal-services.component.scss'],
  standalone: false,
})
export class AdditonalServicesComponent implements OnInit, OnChanges {
  @ViewChild('owlCarousel') owlCarousel: any;

  @Input() additionalServices: AdditionalServiceAddon[] = [];
  @Input() isFetching: boolean;
  additionalServicesCard: AdditionalServiceAddonCard[] = [];

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    autoHeight: true,
    navText: ['', ''],
    margin: 16,
    responsive: {
      0: {
        items: 1,
      },
      750: {
        items: 2,
      },
      1150: {
        items: 3,
      },
    },
    nav: true,
  };

  constructor(
    private router: Router,
    private headerService: HeaderService,
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['additionalServices']) {
      this.additionalServicesCard = this.additionalServices.map((service: AdditionalServiceAddon) => {
        return {
          ...service,
          icon: this.renderIconByServiceName(service.name as ServiceAddonNames),
          title: service?.isEvergreenTile
            ? `${service.displayName} includes`
            : `Add ${service.displayName} to Your UDT HUB!`,
        };
      });
    }
  }

  prevSlide() {
    this.owlCarousel.prev();
  }

  nextSlide() {
    this.owlCarousel.next();
  }

  disablePrevSlide() {
    return this.owlCarousel?.navData()?.prev.disabled;
  }

  disableNextSlide() {
    return this.owlCarousel?.navData()?.next.disabled;
  }

  renderIconByServiceName(serviceName: ServiceAddonNames) {
    switch (serviceName) {
      case 'shop':
        return '../../../../../assets/images/icons/shop-icon-white.svg';
      case 'atms':
      case 'lifecycle-command':
        return '../../../../../assets/images/icons/atms-icon-white.svg';
      case 'cyber-dashboard':
        return '../../../../../assets/images/icons/cyberdash-icon-white.svg';
      case 'managed-services':
        return '../../../../../assets/images/icons/ms-icon-white.svg';
      case 'order-tracking':
        return '../../../../../assets/images/icons/ot-icon-white.svg';
      case 'repair-services':
        return '../../../../../assets/images/icons/rps-icon-white.svg';
      case 'connectivity-services':
        return '../../../../../assets/images/icons/nav-icon_connectivity-services.svg';
      case 'project-services':
        return '../../../../../assets/images/icons/pmo-icon-white.svg';
      default:
        return '../../../../../assets/images/icons/atms-icon-white.svg';
    }
  }

  onAddServiceClick(serviceName: ServiceAddonNames | EverGreenTile) {
    switch (serviceName) {
      case 'shop':
        this.router.navigateByUrl(shopCrossSelling);
        return;
      case 'atms':
        this.router.navigateByUrl(atmsCrossSelling);
        return;
      case 'cyber-dashboard':
        this.router.navigateByUrl(cyberDashboardCrossSelling);
        return;
      case 'managed-services':
        this.router.navigateByUrl(managedServicesCrossSelling);
        return;
      case 'order-tracking':
        this.router.navigateByUrl(orderTrackingCrossSelling);
        return;
      case 'repair-services':
        this.router.navigateByUrl(repairServicesCrossSelling);
        return;
      case 'roles-permissions':
        this.router.navigateByUrl(userPermissions);
        return;
      case 'help-center':
        this.headerService.toggleHelpCenter(true);
        return;
      case 'connectivity-services':
        this.router.navigateByUrl(connectivityServicesCrossSelling);
        return;
      default:
        this.router.navigateByUrl(repairServicesCrossSelling);
    }
  }
}
